/** Worldwide city → [lat, lng] lookup. ~300 major cities across all continents. */
export const CITY_COORDS: Record<string, [number, number]> = {
  // North America
  'new york': [40.7128, -74.006],
  'los angeles': [34.0522, -118.2437],
  'chicago': [41.8781, -87.6298],
  'houston': [29.7604, -95.3698],
  'phoenix': [33.4484, -112.074],
  'philadelphia': [39.9526, -75.1652],
  'san antonio': [29.4241, -98.4936],
  'san diego': [32.7157, -117.1611],
  'dallas': [32.7767, -96.797],
  'san jose': [37.3382, -121.8863],
  'austin': [30.2672, -97.7431],
  'jacksonville': [30.3322, -81.6557],
  'san francisco': [37.7749, -122.4194],
  'seattle': [47.6062, -122.3321],
  'denver': [39.7392, -104.9903],
  'nashville': [36.1627, -86.7816],
  'portland': [45.5051, -122.675],
  'miami': [25.7617, -80.1918],
  'atlanta': [33.749, -84.388],
  'minneapolis': [44.9778, -93.265],
  'boston': [42.3601, -71.0589],
  'detroit': [42.3314, -83.0458],
  'las vegas': [36.1699, -115.1398],
  'charlotte': [35.2271, -80.8431],
  'louisville': [38.2527, -85.7585],
  'baltimore': [39.2904, -76.6122],
  'washington dc': [38.9072, -77.0369],
  'washington': [38.9072, -77.0369],
  'toronto': [43.6532, -79.3832],
  'montreal': [45.5017, -73.5673],
  'vancouver': [49.2827, -123.1207],
  'calgary': [51.0447, -114.0719],
  'ottawa': [45.4215, -75.6972],
  'edmonton': [53.5461, -113.4938],
  'mexico city': [19.4326, -99.1332],
  'guadalajara': [20.6597, -103.3496],
  'monterrey': [25.6866, -100.3161],
  // South America
  'sao paulo': [-23.5505, -46.6333],
  'rio de janeiro': [-22.9068, -43.1729],
  'buenos aires': [-34.6037, -58.3816],
  'bogota': [4.711, -74.0721],
  'lima': [-12.0464, -77.0428],
  'santiago': [-33.4489, -70.6693],
  'caracas': [10.4806, -66.9036],
  'quito': [-0.1807, -78.4678],
  'medellin': [6.2518, -75.5636],
  'belo horizonte': [-19.9167, -43.9345],
  'montevideo': [-34.9011, -56.1645],
  'asuncion': [-25.2867, -57.647],
  'la paz': [-16.5, -68.15],
  'manaus': [-3.119, -60.0217],
  // Europe
  'london': [51.5074, -0.1278],
  'paris': [48.8566, 2.3522],
  'berlin': [52.52, 13.405],
  'madrid': [40.4168, -3.7038],
  'rome': [41.9028, 12.4964],
  'amsterdam': [52.3676, 4.9041],
  'brussels': [50.8503, 4.3517],
  'vienna': [48.2082, 16.3738],
  'zurich': [47.3769, 8.5417],
  'stockholm': [59.3293, 18.0686],
  'oslo': [59.9139, 10.7522],
  'copenhagen': [55.6761, 12.5683],
  'helsinki': [60.1699, 24.9384],
  'lisbon': [38.7223, -9.1393],
  'barcelona': [41.3851, 2.1734],
  'milan': [45.4654, 9.1859],
  'munich': [48.1351, 11.582],
  'frankfurt': [50.1109, 8.6821],
  'hamburg': [53.5753, 10.0153],
  'prague': [50.0755, 14.4378],
  'warsaw': [52.2297, 21.0122],
  'budapest': [47.4979, 19.0402],
  'bucharest': [44.4268, 26.1025],
  'athens': [37.9838, 23.7275],
  'istanbul': [41.0082, 28.9784],
  'kiev': [50.4501, 30.5234],
  'kyiv': [50.4501, 30.5234],
  'moscow': [55.7558, 37.6173],
  'st. petersburg': [59.9311, 30.3609],
  'zurich': [47.3769, 8.5417],
  'geneva': [46.2044, 6.1432],
  'dublin': [53.3498, -6.2603],
  'edinburgh': [55.9533, -3.1883],
  'manchester': [53.4808, -2.2426],
  'birmingham': [52.4862, -1.8904],
  'rotterdam': [51.9225, 4.4792],
  'antwerp': [51.2194, 4.4025],
  'lyon': [45.764, 4.8357],
  'marseille': [43.2965, 5.3698],
  // Africa
  'cairo': [30.0444, 31.2357],
  'lagos': [6.5244, 3.3792],
  'nairobi': [-1.2921, 36.8219],
  'johannesburg': [-26.2041, 28.0473],
  'cape town': [-33.9249, 18.4241],
  'casablanca': [33.5731, -7.5898],
  'accra': [5.6037, -0.187],
  'addis ababa': [9.03, 38.74],
  'dar es salaam': [-6.7924, 39.2083],
  'khartoum': [15.5007, 32.5599],
  'algiers': [36.7372, 3.0865],
  'tunis': [36.8065, 10.1815],
  'abidjan': [5.3486, -4.0064],
  'dakar': [14.6928, -17.4467],
  'lusaka': [-15.4167, 28.2833],
  'harare': [-17.8252, 31.0335],
  'kampala': [0.3476, 32.5825],
  'kigali': [-1.9706, 30.1044],
  'maputo': [-25.9692, 32.5732],
  'luanda': [-8.8368, 13.2343],
  // Middle East
  'dubai': [25.2048, 55.2708],
  'abu dhabi': [24.4539, 54.3773],
  'riyadh': [24.7136, 46.6753],
  'jeddah': [21.4858, 39.1925],
  'doha': [25.2854, 51.531],
  'kuwait city': [29.3759, 47.9774],
  'muscat': [23.5880, 58.3829],
  'manama': [26.2235, 50.5876],
  'amman': [31.9539, 35.9106],
  'beirut': [33.8938, 35.5018],
  'tel aviv': [32.0853, 34.7818],
  'baghdad': [33.3406, 44.4009],
  'tehran': [35.6892, 51.389],
  'ankara': [39.9334, 32.8597],
  // Asia - South
  'mumbai': [19.076, 72.8777],
  'delhi': [28.6139, 77.209],
  'new delhi': [28.6139, 77.209],
  'bangalore': [12.9716, 77.5946],
  'chennai': [13.0827, 80.2707],
  'kolkata': [22.5726, 88.3639],
  'hyderabad': [17.385, 78.4867],
  'karachi': [24.8607, 67.0011],
  'lahore': [31.5804, 74.3587],
  'dhaka': [23.8103, 90.4125],
  'colombo': [6.9271, 79.8612],
  'kathmandu': [27.7172, 85.324],
  'islamabad': [33.6844, 73.0479],
  // Asia - East & Southeast
  'beijing': [39.9042, 116.4074],
  'shanghai': [31.2304, 121.4737],
  'guangzhou': [23.1291, 113.2644],
  'shenzhen': [22.5431, 114.0579],
  'chengdu': [30.5728, 104.0668],
  'wuhan': [30.5928, 114.3055],
  'hangzhou': [30.2741, 120.1551],
  'nanjing': [32.0603, 118.7969],
  'xi\'an': [34.3416, 108.9398],
  'chongqing': [29.4316, 106.9123],
  'hong kong': [22.3193, 114.1694],
  'taipei': [25.033, 121.5654],
  'seoul': [37.5665, 126.978],
  'busan': [35.1796, 129.0756],
  'tokyo': [35.6762, 139.6503],
  'osaka': [34.6937, 135.5023],
  'yokohama': [35.4437, 139.638],
  'nagoya': [35.1815, 136.9066],
  'sapporo': [43.0618, 141.3545],
  'singapore': [1.3521, 103.8198],
  'kuala lumpur': [3.139, 101.6869],
  'jakarta': [-6.2088, 106.8456],
  'bangkok': [13.7563, 100.5018],
  'ho chi minh city': [10.8231, 106.6297],
  'hanoi': [21.0245, 105.8412],
  'manila': [14.5995, 120.9842],
  'phnom penh': [11.5564, 104.9282],
  'yangon': [16.8661, 96.1951],
  'vientiane': [17.9757, 102.6331],
  'bali': [-8.3405, 115.092],
  'surabaya': [-7.2575, 112.7521],
  // Oceania
  'sydney': [-33.8688, 151.2093],
  'melbourne': [-37.8136, 144.9631],
  'brisbane': [-27.4698, 153.0251],
  'perth': [-31.9505, 115.8605],
  'adelaide': [-34.9285, 138.6007],
  'auckland': [-36.8509, 174.7645],
  'wellington': [-41.2865, 174.7762],
  'christchurch': [-43.532, 172.6306],
  // Central Asia
  'almaty': [43.2551, 76.9126],
  'tashkent': [41.2995, 69.2401],
  'baku': [40.4093, 49.8671],
  'tbilisi': [41.7151, 44.8271],
  'yerevan': [40.1872, 44.5152],
};

export function getCityCoords(cityCountryStr: string): [number, number] | null {
  const input = cityCountryStr.toLowerCase().trim();
  // Try exact match first
  if (CITY_COORDS[input]) return CITY_COORDS[input];
  // Try just the city part (before comma)
  const cityPart = input.split(',')[0].trim();
  if (CITY_COORDS[cityPart]) return CITY_COORDS[cityPart];
  // Partial match
  for (const [key, coords] of Object.entries(CITY_COORDS)) {
    if (cityPart.includes(key) || key.includes(cityPart)) return coords;
  }
  return null;
}
